import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// ========== PARTS ==========
import NavBar from '../parts/NavBar';
import Footer from '../parts/Footer';
import Directory from '../parts/Directory';

// ========== ELEMENTS ==========
import Loader from '../elements/Loader';

export class States extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      element: null
    };
  }

  async getRootDirectory() {
    let response = await window.doRequest('GET', {
      action: 'getDirectoryContent',
      id: 1,
      token: sessionStorage.getItem('token')
    });

    if (response.status) {

      this.setState({
        loading: false,
        element: <Directory
                    id={1}
                    name={response.content.info.name}
                    type={response.content.info.type}
                    directory_list={response.content.directory_list}
                    file_list={response.content.file_list}
                    privileges={response.content.info.privileges}
                  />
      })

    } else {
      window.alert(response.message);
    }
  }

  componentDidMount() {
    window.verifyIfIsLogged();

    this.getRootDirectory();
  }

  render() {
    return (
      <main>
        <NavBar />
        <section id="dashboard">
          <div className="container">
            {
              (this.state.loading)
                ? <Loader />
                : this.state.element
            }
          </div>
        </section>
        <Footer />
      </main>
    );
  }
}

export default States
